export const SERVICE_BREADCRUMB_LABEL = 'Serviço';
